<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-container>
        <div class="d-flex align-center mb-3">
            <h1 class="titulo">LISTAGEM DE RESERVAS</h1>
        </div>
        <Banner
                type="warning"
                icon="mdi-information"
                title="Informativo"
                class="d-flex w-100"
                :max-width="false"
        >
            Caso o botão "Mais Detalhes" esteja <strong>amarelo</strong>, é um indicativo de que <strong>uma ou mais cotas de sua reserva carrinho não foram geradas</strong>, tente novamente no <strong>botão de "Ações" dentro do "Mais Detalhes".</strong>
        </Banner>
        <v-card>
            <v-card-text>
                <v-layout>
                    <v-btn class="transition" color="primary" rounded @click="filter_open = !filter_open">
                        <v-icon small style="margin-right: 10px;">rod-filter</v-icon>
                        Filtrar por:
                        <v-icon :class="{ 'rotate90': filter_open }" small>chevron_right</v-icon>
                    </v-btn>
                </v-layout>
                <collapse-transition>
                    <m-form ref="filter"
                            class="pt-6"
                            v-show="filter_open">
                        <v-row>
                            <v-col cols="12" sm="4">
                                <m-text-field label="Grupo: "
                                              outlined
                                              v-uppercase
                                              v-model="filters.grupo"
                                              v-input-filter="[$filters.alphanumeric]" />
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <DateField ref="data_inicial"
                                           label="Data inicial da reserva: "
                                           v-model="filters.data_inicial"
                                           :rules="[validaDataInicial, $rules.date, $rules.dataPassada]"
                                           max="today"
                                           @input="validaDatas" />
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <DateField ref="data_final"
                                           label="Data final da reserva: "
                                           v-model="filters.data_final"
                                           :rules="[validaDataFinal, $rules.date, $rules.dataPassada]"
                                           max="today"
                                           @input="validaDatas" />
                            </v-col>
                        </v-row>
                        <v-row class="d-flex justify-space-between pa-0">
                            <v-col cols="6" sm="3" class="mb-2 d-flex">
                                <v-input style="align-self: flex-end">
                                    <v-btn color="secondary" block @click="searchClean">
                                        Limpar
                                    </v-btn>
                                </v-input>
                            </v-col>
                            <v-col cols="12" sm="4" v-if="showComissionados">
                                <v-select v-model="filters.comissionado"
                                          placeholder="Selecione o comissionado"
                                          :items="comissionados"
                                          outlined
                                          label="Comissionado: "
                                          :item-text="comissionadoDescription"
                                          item-value="ID_Comissionado" />
                            </v-col>

                            <v-col cols="6" sm="3" class="mb-2 d-flex">
                                <v-input style="align-self: flex-end">
                                    <v-btn color="primary" block @click="filtrar">
                                        Filtrar
                                    </v-btn>
                                </v-input>
                            </v-col>
                        </v-row>
                    </m-form>
                </collapse-transition>
                <v-divider class="ma-2 lightgray mb-10" />
                <v-data-iterator :items="items"
                                 :items-per-page.sync="itemsPerPage"
                                 :page.sync="page"
                                 :footer-props="footerProps"
                                 style="text-align: center"
                                 no-data-text="Não há dados disponíveis"
                                 no-results-text="Não há dados disponíveis"
                                 :custom-filter="customFilter">
                    <template v-slot="props">
                        <div v-for="(item, index) in props.items" :key="item.id_reserva || item.id_carrinho || index" class="px-8 mb-5">
                            <v-card-text :class="{ 'disabled-card-text': item.reserva_em_geracao && !reservasEmGeracaoTodasComErro(item) }" class="v-card pl-6 my-2 round-corner pointer position-relative transition" @click="openDetalhes(item)">
                                <div class="primary circle d-flex align-center justify-center">
                                    <v-icon color="white" class="icon text-center">
                                        {{ getIcon(item.id_produto) }}
                                    </v-icon>
                                </div>
                                <v-row no-gutters>
                                    <v-col class="cabecalho primary--text" cols="12" :md="showComissionados ? TAMANHOS_COLUNA_CARD_RESERVA.COLUNA_TITULO_SEM_COMISSIONADO : TAMANHOS_COLUNA_CARD_RESERVA.COLUNA_TITULO_COM_COMISSIONADO">
                                        {{ item.reserva_agrupada ? getTipoProduto(item.id_produto,item.reserva_agrupada) : `${getTipoProduto(item.id_produto)} - Nº ${item.id_reserva}` }}
                                    </v-col>
                                    <v-col cols="12" :md="showComissionados ? TAMANHOS_COLUNA_CARD_RESERVA.COLUNA_GRUPO_COM_COMISSIONADO : TAMANHOS_COLUNA_CARD_RESERVA.COLUNA_GRUPO_SEM_COMISSIONADO">
                                        <v-col>{{ item.reserva_agrupada ? 'Grupo:' : 'Grupo/Cota:' }}</v-col>
                                        <v-col class="primary--text">
                                            {{ grupoDescription(item) }}
                                        </v-col>
                                    </v-col>
                                    <v-col cols="12" v-if="showComissionados" md="3">
                                        <v-col>Comissionado:</v-col>
                                        <v-col class="primary--text">
                                            {{ getComissionado(item.id_comissionado) }}
                                        </v-col>
                                    </v-col>
                                    <v-col cols="12" md="3">
                                        <v-col>Quantidade de Cotas:</v-col>
                                        <v-col class="primary--text">
                                            {{ item.reserva_agrupada ? item.qt_cota : QUANTIDADE_COTAS_PADRAO }}
                                        </v-col>
                                    </v-col>
                                    <v-col cols="12" :md="showComissionados ? TAMANHOS_COLUNA_CARD_RESERVA.COLUNA_DATA_COM_COMISSIONADO : TAMANHOS_COLUNA_CARD_RESERVA.COLUNA_DATA_SEM_COMISSIONADO">
                                        <v-col>{{ item.reserva_em_geracao ? 'Data de criação' : 'Data de expiração' }}</v-col>
                                        <v-col class="primary--text">
                                            {{ item.dt_validade | toDateBR }}
                                        </v-col>
                                    </v-col>

                                    <v-col cols="12" md="2">
                                        <template v-if="!item.reserva_em_geracao || reservasEmGeracaoTodasComErro(item)">
                                            <v-btn :color="(item.id_carrinho && (item.erro_reserva > 0 || !item.dt_validade)) ? '#FFB800' : 'secondary'" small>
                                                Mais detalhes
                                            </v-btn>
                                        </template>
                                        <template v-else>
                                            <IndicativoReservasComponent
                                                    :id-carrinho="parseInt(item.id_carrinho)"
                                                    :erro-reserva="item.erro_reserva"
                                                    v-if="iniciarIndicativoReservas(item)"
                                            />
                                        </template>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                        </div>
                    </template>
                </v-data-iterator>
                <v-row class="justify-center mt-4">
                    <v-col cols="12" md="2">
                        <v-btn id="novaReservaBtn" color="primary" block @click="nova_reserva">
                            NOVA RESERVA
                        </v-btn>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
        <v-dialog v-model="dialog_detalhes" persistent max-width="500">
            <v-card>
                <v-card-title class="headline title pb-0">
                    <button class="close-button" @click="dialog_detalhes = false">
                        <v-icon>close</v-icon>
                    </button>
                    <v-layout class="column align-center">
                        <span color="secondary">DETALHES DA RESERVA</span>
                        <span class="title subtitle">{{ getTipoProduto(item.id_produto) }} - Nº {{ item.id_reserva }}</span>
                    </v-layout>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                    <v-row>
                        <v-col cols="6" class="my-2">
                            <v-col>Grupo/Cota:</v-col>
                            <v-col class="cabecalho">
                                {{ grupoDescription(item) }}
                            </v-col>
                        </v-col>
                        <v-col cols="6" class="my-2">
                            <v-col>Comissionado:</v-col>
                            <v-col class="cabecalho">
                                {{ getComissionado(item.id_comissionado) }}
                            </v-col>
                        </v-col>
                        <v-col cols="6" class="my-2">
                            <v-col>{{ item.reserva_agrupada ? 'Data de criação' : 'Data de expiração' }}</v-col>
                            <v-col class="cabecalho">
                                {{ item.dt_validade | toDateBR }}
                            </v-col>
                        </v-col>
                        <v-col cols="6" class="my-2">
                            <v-col>Bem:</v-col>
                            <v-col class="cabecalho">
                                {{ item.nm_bem ? item.nm_bem : '-' }}
                            </v-col>
                        </v-col>
                        <v-col cols="6" class="my-2">
                            <v-col>Plano:</v-col>
                            <v-col class="cabecalho">
                                {{ item.nome_plano ? item.nome_plano : '-' }}
                            </v-col>
                        </v-col>
                        <v-col cols="6" class="my-2">
                            <v-col>Prazo reservado:</v-col>
                            <v-col class="cabecalho">
                                {{ item.pz_comercializacao ? item.pz_comercializacao : '-' }}
                            </v-col>
                        </v-col>
                        <v-col cols="6" class="my-2">
                            <v-col>Data de criação:</v-col>
                            <v-col class="cabecalho">
                                {{ item.dt_reserva | toDateBR }}
                            </v-col>
                        </v-col>
                    </v-row>
                    <v-row class="justify-center mt-4">
                        <v-col cols="6">
                            <v-btn id="ButtonUtilizarReserva" block color="secondary" @click="utilizarReserva">
                                {{ isRascunho(item) ? 'EDITAR RESERVA' : 'UTILIZAR RESERVA' }}
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-dialog>
        <ListDialog v-model="dialog_nova_reserva"
                    title="GRUPOS DISPONÍVEIS"
                    :items="grupos"
                    placeholder="Buscar por código do grupo"
                    show-close-button
                    :search-keys="['CD_Grupo']">
            <template v-slot:item="props">
                <v-list-item @click="selecionarGrupo(props.item)" :disabled="isGrupoBloqueado(props.item)">
                    {{ trimZeros(props.item.CD_Grupo) }}{{ getGrupoMsgErro(props.item) }}
                </v-list-item>
            </template>
        </ListDialog>
        <ReservaMultiplasDetalhesDialog
                v-model="dialog_detalhes_multiplas_cotas"
                :item="item"
                @utilizarReservasMultiplas="utilizarReservasMultiplas"
                @atualizaTelaECarrinho="atualizaTelaECarrinho"
        />
        <DialogQuantidadeCotas v-model="dialog_quantidade_cotas"
                               :grupo="grupo"
                               show-back-button
                               :quantidade-cotas="quantidade_cotas"
                               @voltar="voltarDialogQuantidadeCotas"
                               @setQuantidadeCotas="setQuantidadeCotas" />
        <DialogListagemCotas v-model="dialog_cotas_disponiveis"
                             :dados="grupo"
                             :quantidade-cotas="quantidade_cotas"
                             show-back-button
                             @voltar="voltarDialogSelecaoCotas"
                             @reservado="atualizaReservado"
                             @atualizarLista="loadReservas"
                             @utilizarReserva="utilizarReserva"
        />

        <ListDialog v-model="dialog_filial"
                    title="ESCOLHA A FILIAL"
                    :items="filiais_visiveis"
                    :search-keys="['CD_Filial_Venda','NM_Filial_Venda']"
                    @select="selecionarFilial"
                    :item-text="filialTextDialog" />
    </v-container>
</template>

<script>
  import { merge, orderBy } from 'lodash'
  import moment from 'moment'
  import { mapGetters, mapState } from 'vuex'
  import { trimZeros, existHierarchy, notification } from '@/plugins/helpers'
  import DialogListagemCotas from '@/dialogs/DialogListagemCotas'
  import { OrigemReserva, SituacaoGrupo } from '@/plugins/constants'
  import { permiteEditar } from '@/views/MinhasVendas'
  import { sendAnalyticsEvent } from '../plugins/googleAnalytics'
  import conferirIntegridadeIniciarVenda from '../mixins/CommercialHierarchy/conferirIntegridadeIniciarVenda'
  import DetalhesReservaTexts from '../mixins/Reserva/DetalhesReservaTexts'
  import { AlertTypes } from '../plugins/alerts_types'
  import DialogQuantidadeCotas from '../dialogs/reserva/DialogQuantidadeCotas.vue'
  import { TAMANHOS_COLUNA_CARD_RESERVA, QUANTIDADE_COTAS_PADRAO } from '../helpers/reserva_helper'
  import IndicativoReservasComponent from '../components/carrinho/reservas/IndicativoReservasComponent.vue'
  import ReservaMultiplasDetalhesDialog from '../dialogs/reserva/ReservaMultiplasDetalhesDialog.vue'
  import loadFiliais from '../mixins/loadFiliais'
  import Banner from '../components/common/Banner.vue'
  import { PollingService } from '@/helpers/polling'
  import { verificarAtualizacoesReservas, marcarNotificacoesEnviadas } from '@/webservice/reservas'
  export default {
    name: 'Reservas',
    components: {
      DialogListagemCotas,
      DialogQuantidadeCotas,
      ReservaMultiplasDetalhesDialog,
      IndicativoReservasComponent,
      Banner
    },
    mixins: [
      conferirIntegridadeIniciarVenda,
      DetalhesReservaTexts,
      loadFiliais
    ],
    data: () => ({
      TAMANHOS_COLUNA_CARD_RESERVA,
      QUANTIDADE_COTAS_PADRAO,
      post_filial_escolhida: Function,
      filter_open: false,
      dialog_detalhes: false,
      dialog_detalhes_multiplas_cotas: false,
      dialog_nova_reserva: false,
      dialog_filial: false,
      dialog_cotas_disponiveis: false,
      dialog_quantidade_cotas: false,
      quantidade_cotas: 1,
      grupos: [],
      cotas: [],
      grupo: {},
      filters: {
        nm_bem: '',
        comissionado: '',
        grupo: '',
        plano_venda: '',
        data_inicial: '',
        data_final: ''
      },
      page: 1,
      itemsPerPage: 12,
      items: [],
      search: {
        nm_bem: '',
        comissionado: '',
        grupo: '',
        plano_venda: '',
        data_inicial: '',
        data_final: ''
      },
      item: {
        cd_cota: '',
        dt_reserva: '',
        dt_validade: '',
        id_bem: '',
        id_comissionado: '',
        id_condicao_pagto: '',
        id_filial_venda: '',
        id_grupo: '',
        id_plano_venda: '',
        id_ponto_venda: '',
        id_taxa_plano: '',
        id_produto: '',
        id_reserva: '',
        id_tipo_venda: '',
        id_regiao_fiscal: 1,
        pz_comercializacao: '',
        st_tipo_venda: '',
        situacao_grupo: '',
        completa: '',
        origem: ''
      },
      filiais_visiveis: [],
      reservas: [],
      // Propriedades para polling automático
      pollingService: null,
      hashAtual: null,
      eventosExibidos: new Set(),
      // Intervalo para atualização de reservas do carrinho
      atualizarReservasDoCarrinhoInterval: null
    }),
    computed: {
      ...mapState([
        'id_comissionado',
        'id_ponto_venda',
        'id_comissionado_venda',
        'id_unidade_negocio',
        'id_empresa',
        'comissionados',
        'modalidades',
        'hierarquia_comercial',
        'vendas_backoffice',
        'permite_multiplicar_cota'
      ]),
      is_user_hierarquia () {
        return existHierarchy(this.hierarquia_comercial)
      },
      ...mapGetters([
        'filial',
        'filiais',
        'dadosRestricaoVenda'
      ]),
      showComissionados () {
        return this.comissionados.length > 1 && this.id_comissionado_venda === this.id_comissionado
      },
      footerProps: () => ({
        'items-per-page-options': [ 12, 25, 50 ]
      }),
      trimZeros: () => trimZeros
    },
    watch: {
      id_comissionado_venda () {
        this.verificarSePodeProsseguirVenda()
        this.loadReservas()
      },
      id_empresa () {
        this.loadReservas()
      }
    },
    beforeDestroy () {
      // Remove listener de visibilidade da página
      if (this._visibilityChangeHandler) {
        document.removeEventListener('visibilitychange', this._visibilityChangeHandler)
      }

      this.pararPolling()

      this.eventosExibidos.clear()

      clearInterval(this.atualizarReservasDoCarrinhoInterval)
      this.atualizarReservasDoCarrinhoInterval = null
    },
    async mounted () {
      this.verificarSePodeProsseguirVenda()
      await this.loadReservas()
      await this.loadFiliais()

      this.iniciarPolling()

      this.configurarPollingListaReservas()

      this._visibilityChangeHandler = () => this.handleVisibilityChange()

      document.addEventListener('visibilitychange', this._visibilityChangeHandler)
    },
    methods: {
      async atualizaTelaECarrinho (id_carrinho) {
        await this.loadReservas()
        this.item = {}
        this.item = this.items.find(item => item.id_carrinho === id_carrinho)
      },
      voltarDialogQuantidadeCotas () {
        this.dialog_quantidade_cotas = false
        this.dialog_nova_reserva = true
      },
      voltarDialogSelecaoCotas () {
        this.dialog_cotas_disponiveis = false
        this.dialog_quantidade_cotas = true
      },
      selecionarGrupo (grupo) {
        this.quantidade_cotas = 1
        this.dialog_quantidade_cotas = true
        this.dialog_nova_reserva = false
        this.grupo = {
          ID_Empresa: this.id_empresa,
          ID_Bem: 0,
          ID_Produto: grupo['ID_Produto'],
          ID_Plano_Venda: 0,
          ID_Tipo_Venda: 0,
          ID_Ponto_Venda: this['id_ponto_venda'],
          ID_Comissionado: this['id_comissionado_venda'],
          ID_Grupo: grupo['ID_Grupo'],
          PZ_Comercializacao: 0,
          CD_Cota: 0,
          ID_Filial_Venda: this.$session.get('filial').ID_Filial_Venda,
          ST_Reserva: '',
          CD_Grupo: grupo['CD_Grupo'],
          origem: OrigemReserva.TelaReservas
        }
        this.pedido.id_grupo = grupo['ID_Grupo']
      },
      filialTextDialog (item) { return `${item.CD_Filial_Venda} - ${item.NM_Filial_Venda}` },
      atualizaReservado (reservado) {
        this.item = { reservado, id_reserva: reservado.ID_Reserva }
        this.loadReservas()
      },
      setQuantidadeCotas (quantidadeCotas) {
        this.quantidade_cotas = quantidadeCotas
        this.dialog_quantidade_cotas = false
        this.dialog_cotas_disponiveis = true
      },
      searchClean () {
        let clean = {
          nm_bem: '',
          comissionado: '',
          grupo: '',
          plano_venda: '',
          data_inicial: '',
          data_final: ''
        }
        this.search = { ...clean }
        this.filters = { ...clean }
      },
      verificaSePrecisaEscolherFilial () {
        return ((!!this.filial) && (this.filial.constructor === Array)) && (((this.$session.get('filial')).constructor === Object) && Object.keys(this.$session.get('filial')).length === 0)
      },
      async utilizarReserva () {
        if (this.verificaSePrecisaEscolherFilial()) {
          this.post_filial_escolhida = this.utilizarReservaRaw
          this.dialog_filial = true
        } else {
          await this.utilizarReservaRaw()
        }
      },
      async utilizarReservasMultiplas (selectedIds) {
        this.item.desmenbrarProposta = selectedIds.length < this.item.qt_cota
        this.item.cotasDesejadas = selectedIds
        if (this.verificaSePrecisaEscolherFilial()) {
          this.post_filial_escolhida = this.utilizarReservaRaw
          this.dialog_filial = true
        } else {
          await this.utilizarReservaRaw(selectedIds)
        }
      },
      async utilizarReservaRaw () {
        this.sendAnalytics()
        if (this.item.id_pedido) {
          await permiteEditar(this.item)
        }
        if (this.item.completa) {
          await this.$http.get('/grupos/online/reserva', {
            params: {
              ID_Bem: this.item.id_bem,
              ID_Plano_Venda: this.item.id_plano_venda,
              ID_Taxa_Plano: this.item.id_taxa_plano,
              ID_Tipo_Venda_Grupo: this.item.id_tipo_venda,
              ID_Regiao_Fiscal: 1,
              ID_Reserva: this.item.id_reserva,
              ST_Tipo_Venda: this.item.st_tipo_venda,
              ST_Situacao: this.item.situacao_grupo ? (this.item.situacao_grupo === SituacaoGrupo.Formacao ? 'F' : 'A') : '',
              id_grupo: this.item.id_grupo
            }
          })
            .then(result => {
              if (result.data['Msg_Erro']) {
          notification(AlertTypes.ERROR, `Condições selecionadas da reserva não estão disponíveis para venda! ${result.data['Msg_Erro']}.`)
              } else {
                if (!this.item.id_pedido && this.item.origem !== 'politica_vendas') {
                  this.criarVenda()
                } else {
                  this.irParaCadastro()
                }
              }
            })
            .catch(err => notification(AlertTypes.ERROR, err, 'Não foi possível consultar as condições da reserva!'))
        } else {
          this.irParaCadastro()
        }
      },
      sendAnalytics () {
        const reservaToSendAnalytics = this.getReservaNewconOrReservaToSendAnalytics(this.item)
        sendAnalyticsEvent(this.$gtag, 'utilizar_reserva', {
          cota_reservada: reservaToSendAnalytics.cota_reservada,
          data_reserva: reservaToSendAnalytics.data_reserva,
          grupo: reservaToSendAnalytics.grupo,
          data_expiracao: reservaToSendAnalytics.data_expiracao
        })
      },
      getReservaNewconOrReservaToSendAnalytics (reserva) {
        let payload = {
          'cota_reservada': '',
          'data_reserva': '',
          'grupo': '',
          'data_expiracao': ''
        }
        try {
          if (reserva.reserva_agrupada) {
            // Coleta todas as cotas desejadas
            if (reserva.cotasDesejadas && reserva.cotasDesejadas.length > 0) {
              const cotasSelecionadas = reserva.todasAsReservasAgrupadas
                .filter(cota => reserva.cotasDesejadas.includes(cota.id_reserva))
                .map(cota => cota.cd_cota)

              payload.cota_reservada = cotasSelecionadas.length > 0 ? cotasSelecionadas.join(',') : ''
            } else if (reserva.todasAsReservasAgrupadas) {
              const todasAsCotas = reserva.todasAsReservasAgrupadas.map(cota => cota.cd_cota).join(',')
              payload.cota_reservada = todasAsCotas // Se não houver cotas desejadas, pega todas as cotas
            }
            payload.data_reserva = reserva.dt_reserva
            payload.grupo = reserva.grupo.cd_grupo
            payload.data_expiracao = reserva.dt_validade
          } else if (reserva.cd_cota) {
            payload.cota_reservada = reserva.cd_cota
            payload.data_reserva = reserva.dt_reserva
            payload.grupo = reserva.grupo.cd_grupo
            payload.data_expiracao = reserva.dt_validade
          } else if (reserva.reservado) {
            reserva = reserva.reservado
            payload.cota_reservada = reserva.CD_Cota
            payload.data_reserva = reserva.DT_Reserva
            payload.grupo = reserva.CD_Grupo
            payload.data_expiracao = reserva.DT_Validade
          }
          return payload
        } catch {
          return {
            'cota_reservada': '',
            'data_reserva': '',
            'grupo': '',
            'data_expiracao': ''
          }
        }
      },
      async criarVenda () {
        this.$http.post('/reserva/criar/venda', { ...this.item, ...this.$session.get('filial'), vl_parcela: this.item.vl_fisica, nome_bem: this.item.nm_bem })
          .then(result => {
            this.item = { ...result.data }
            this.irParaCadastro()
          })
          .catch(err => notification(AlertTypes.ERROR, err, 'Não foi possível criar a venda para reserva completa!'))
      },
      nova_reserva () {
        if (this.filiais_visiveis.length > 1) {
          this.dialog_filial = true
          this.post_filial_escolhida = this.criarNovaReserva
        } else if (this.filiais_visiveis.length === 1) {
          const filial = this.filiais_visiveis[0]
          this.selecionarFilial(filial)
          this.criarNovaReserva()
        } else {
          notification(AlertTypes.ERROR, 'Nenhuma filial foi encontrada na empresa vinculada.')
        }
      },
      async selecionarFilial (filial) {
        this.$session.set('filial', filial)
        this.dialog_filial = false
        await this.post_filial_escolhida()
      },
      criarNovaReserva () {
        if (!this.$session.get('filial')) {
          notification(AlertTypes.ERROR, 'Nenhuma filial foi encontrada na empresa vinculada.')
          return
        }
        const ambientes = this.$session.get('ambiente')
        const unidadeCondicoesVenda = ambientes && ambientes.unidade_condicoes_venda
        this.$http.get('/reservas/grupos/filtrados', {
          params: {
            ID_Empresa: this.id_empresa,
            id_unidade_negocio: this.$session.get('id_unidade_negocio'),
            id_ponto_venda: this.$session.get('id_ponto_venda'),
            id_comissionado: this.$session.get('id_comissionado') || 0,
            id_reserva: 0,
            id_produto: 0,
            flavor: this.$session.get('flavor'),
            dadosRestricaoVenda: this.dadosRestricaoVenda,
            ...(unidadeCondicoesVenda && { unidade_condicoes_venda: unidadeCondicoesVenda })
          }
        })
          .then(result => {
            this.grupos = result.data.GruposReservaFiltrados
            if (!this.grupos) {
              notification(AlertTypes.ERROR, 'Nenhum grupo foi encontrado!')
            } else {
              this.dialog_nova_reserva = true
            }
          })
          .catch(err => notification(AlertTypes.ERROR, err, 'Não foi possível buscar os grupos!'))
      },
      validaDatas () {
        this.$refs.data_inicial.validate()
        this.$refs.data_final.validate()
      },
      validaDataInicial () {
        const data_inicial = moment(this.filters.data_inicial)
        const data_final = moment(this.filters.data_final)

        if (data_final.isValid() && data_inicial.isAfter(data_final)) {
          return 'Data Inicial não pode ser maior que a Data Final!'
        }

        return true
      },
      validaDataFinal () {
        const data_inicial = moment(this.filters.data_inicial)
        const data_final = moment(this.filters.data_final)

        if (data_inicial.isValid() && data_final.isBefore(data_inicial)) {
          return 'Data Final não pode ser menor que a Data Inicial!'
        }

        return true
      },
      async openDetalhes (item) {
        try {
          if (!item?.id_reserva) {
            this.item = merge({}, item)
            if (this.item.reserva_agrupada) {
              this.dialog_detalhes_multiplas_cotas = true
            } else {
              this.dialog_detalhes = true
            }
            return
          }

          const result = await this.$http.get('/reservas/possuivendarascunho', { params: { ID_Reserva: item.id_reserva } })

          this.item = merge({}, item, { ...result.data })
          if (!this.item.nome_plano && this.item.plano?.nome_plano) {
            this.item.nome_plano = result.data.plano.nome_plano
          }

          if (this.item.reserva_agrupada) {
            this.dialog_detalhes_multiplas_cotas = true
          } else {
            this.dialog_detalhes = true
          }
        } catch (err) {
          notification(AlertTypes.ERROR, err, 'Não foi possível verificar as vendas!')
        }
      },
      customFilter (itens) {
        if (this.search.nm_bem) {
          const term = this.search.nm_bem.toLowerCase()
          itens = itens.filter(item => item.nm_bem && item.nm_bem.toLowerCase().includes(term))
        }
        if (this.search.comissionado) {
          itens = itens.filter(item => item.id_comissionado === this.search.comissionado)
        }
        if (this.search.grupo) {
          itens = itens.filter(item => {
            let grupo = ''
            if (item.grupo && item.grupo.cd_grupo) {
              grupo = item.grupo.cd_grupo
            } else if (item.cd_grupo) {
              grupo = item.cd_grupo
            } else {
              grupo = item.id_grupo
            }
            return grupo.includes(this.search.grupo)
          })
        }
        if (this.search.data_inicial) {
          const data_inicial = moment(this.search.data_inicial)
          itens = itens.filter(item => moment(item.dt_reserva).isSameOrAfter(data_inicial))
        }
        if (this.search.data_final) {
          const data_final = moment(this.search.data_final)
          itens = itens.filter(item => moment(item.dt_reserva).isSameOrBefore(data_final))
        }
        return itens
      },
      getIcon (id_produto) {
        let teste = this.getModalidade(+id_produto).icone
        if (!teste) {
          teste = 'rod-carrinho'
        }
        return teste
      },
      getComissionado (id_comissionado) {
        let comissionado = this['comissionados'].find(comissionado => comissionado.ID_Comissionado === id_comissionado || comissionado.idComissionado === id_comissionado)
        return this.comissionadoDescription(comissionado)
      },
      async loadReservas (silent = false) {
        if (!silent) {
          this.searchClean()
        }
        const id_empresa = this.id_empresa
        await this.$http.get('/reservas/listar',
                             { params: { id_empresa, id_comissionado: this.id_comissionado_venda, permite_multiplicar_cota: this.permite_multiplicar_cota }, options: { silent } }
        )
          .then(result => {
            if (result.data) {
              if (result.data.reservas_sem_codigoGrupo && result.data.reservas_sem_codigoGrupo.length > 0) {
                const ids = result.data.reservas_sem_codigo_grupo.join(', ')
                notification(
                  AlertTypes.WARNING,
                  `Caro parceiro, não foi possível encontrar o código do grupo da reserva(s) ${ids}. Por favor, entre em contato com a Área de Suporte.`
                )
              }
              // 🔧 CORREÇÃO: Não chamar detectarENotificarMudancas aqui para evitar duplicação
              // O polling /verificar-atualizacoes (10s) já faz isso de forma otimizada
              // Este método (20s) serve apenas para garantir sincronização completa
              this.processarEAtualizarReservas(Object.values(result.data.Reservas))
            }
          })
          .catch((e) => {
            console.error('[Reservas] Erro ao carregar reservas:', e)
            if (silent) {
              return
            }
            notification(AlertTypes.ERROR, 'Ocorreu uma falha na comunicação com o Newcon, tente novamente mais tarde! Caso persistir, por favor, entre em contato com a Administradora.')
          })
      },
      /**
       * Processa reservas recebidas do backend e atualiza this.items
       * Normaliza dados, filtra por validade/produto e ordena
       * Método auxiliar usado tanto por loadReservas() quanto por verificarAtualizacoes()
       *
       * @param {Array} reservasRaw - Array de reservas brutas do backend
       * @param {Function} onComplete - Callback executado após processamento completo (opcional)
       */
      processarEAtualizarReservas (reservasRaw, onComplete = null) {
        const debugPolling = localStorage.getItem('DEBUG_POLLING') === 'true'

        if (debugPolling) {
          console.log('🔄 [processarEAtualizarReservas] Iniciando processamento:', {
            quantidadeRecebida: reservasRaw.length,
            quantidadeAtual: this.items.length,
            idsRecebidos: reservasRaw.map(r => r.id_reserva || r.id_carrinho).filter(Boolean).join(', '),
            idsAtuais: this.items.map(r => r.id_reserva || r.id_carrinho).filter(Boolean).join(', ')
          })
        }

        this.$nextTick(() => {
          // Normalizar erro_reserva para sempre ser número (0 ou 1)
          const normalizarErroReserva = (item) => {
            if (item.erro_reserva === null || item.erro_reserva === undefined) {
              item.erro_reserva = 0
            } else {
              item.erro_reserva = Number(item.erro_reserva)
            }

            if (item.todasAsReservasAgrupadas && Array.isArray(item.todasAsReservasAgrupadas)) {
              item.todasAsReservasAgrupadas.forEach(subItem => {
                if (subItem.erro_reserva === null || subItem.erro_reserva === undefined) {
                  subItem.erro_reserva = 0
                } else {
                  subItem.erro_reserva = Number(subItem.erro_reserva)
                }
              })
            }
            return item
          }

          // Normalizar dados
          let reservasNormalizadas = reservasRaw.map(normalizarErroReserva)
          this.reservas = [...reservasNormalizadas]

          // Filtrar por validade e produtos válidos
          const hoje = moment().startOf('day')
          const ids_produtos = Object.values(this.modalidades)
            .map(modalidade => modalidade.produtos)
            .flat()
            .map(produto => String(produto.id_produto))

          reservasNormalizadas = reservasNormalizadas.filter(item => {
            const isValidadeOk = moment(item.dt_validade).isSameOrAfter(hoje)
            const isProdutoValido = ids_produtos.includes(String(item.id_produto))

            return (isValidadeOk || item.reserva_agrupada) && (isProdutoValido || item.reserva_agrupada)
          })

          // Ordenar e criar NOVO array (força reatividade)
          const novoArray = orderBy(reservasNormalizadas, ['dt_validade', 'id_reserva'], ['asc', 'desc'])

          // 🔧 FIX: Usar Vue.set para garantir reatividade na substituição completa do array
          this.$set(this, 'items', novoArray)
          this.reservas = [...novoArray]

          if (debugPolling) {
            console.log('✅ [processarEAtualizarReservas] Processamento concluído:', {
              quantidadeFinal: this.items.length,
              quantidadeFiltrada: reservasNormalizadas.length,
              quantidadeRemovida: reservasRaw.length - novoArray.length,
              idsFinal: this.items.map(r => r.id_reserva || r.id_carrinho).filter(Boolean).join(', '),
              reservasEmGeracao: novoArray.filter(r => r.reserva_em_geracao).length,
              detalhesReservasEmGeracao: novoArray
                .filter(r => r.reserva_em_geracao)
                .map(r => ({
                  id: r.id_reserva || r.id_carrinho,
                  reserva_em_geracao: r.reserva_em_geracao,
                  erro_reserva: r.erro_reserva
                }))
            })
          }

          // 🔍 Forçar atualização do DOM para garantir que botões sejam re-renderizados
          this.$forceUpdate()

          // 🔧 FIX: Executar callback após processamento completo
          if (onComplete && typeof onComplete === 'function') {
            onComplete()
          }
        })
      },
      /**
       * Configura polling para /reservas/listar (20s)
       * Atualiza lista completa de reservas continuamente
       * @private
       */
      configurarPollingListaReservas () {
        // Inicia polling se ainda não existir
        if (!this.atualizarReservasDoCarrinhoInterval) {
          this.atualizarReservasDoCarrinhoInterval = setInterval(() => {
            this.loadReservas(true)
          }, 20000) // 20 segundos
        }
      },
      /**
       * Inicia o polling automático para verificar atualizações nas reservas
       *
       * Cria instância do PollingService configurada para:
       * - Intervalo de 10 segundos entre verificações (intervalo fixo)
       * - Máximo de 3 tentativas em caso de erro
       * - Backoff exponencial (1s, 2s, 4s)
       * - Debug ativo em ambiente de desenvolvimento
       * - Polling adaptativo desabilitado (mantém sempre 10s)
       *
       * @see verificarAtualizacoes Callback executado pelo polling
       * @see PollingService Classe que gerencia o ciclo de polling
       */
      iniciarPolling () {
        if (this.pollingService) {
          return // Já existe um polling ativo
        }

        this.pollingService = new PollingService(
          this.verificarAtualizacoes,
          10000, // 10 segundos (intervalo fixo)
          {
            debug: localStorage.getItem('DEBUG_POLLING') === 'true',
            maxRetries: 3,
            initialBackoff: 1000,
            maxBackoff: 4000,
            name: 'polling-reservas',
            adaptivePolling: false, // Desabilita polling adaptativo - mantém sempre 10s
            minInterval: 10000,
            maxInterval: 10000, // Força intervalo máximo igual ao mínimo
            onError: (error) => {
              console.error('[Reservas] Erro no polling:', error)
            },
            onSuccess: () => {
              // Callback de sucesso
            }
          }
        )

        this.pollingService.start()
      },
      /**
       * Callback executado pelo PollingService a cada ciclo de verificação
       *
       * Compara o hash MD5 das reservas atuais com o último conhecido.
       * Se houver diferença, recarrega a lista preservando estado (filtros, paginação, diálogos).
       *
       * @async
       * @throws {Error} Propaga erro para PollingService aplicar retry automático
       *
       * @example
       * // Executado automaticamente a cada 30s pelo polling
       * // Caso encontre mudanças:
       * // 1. Atualiza this.hashAtual
       * // 2. Processa eventos (notificações de sucesso/erro)
       * // 3. Chama loadReservas(true) - modo silencioso
       * // 4. Lista atualiza sem perder filtros ou página
       */
      async verificarAtualizacoes () {
        const debugPolling = localStorage.getItem('DEBUG_POLLING') === 'true'

        try {
          const resultado = await verificarAtualizacoesReservas({
            id_empresa: this.id_empresa,
            id_comissionado: this.id_comissionado_venda,
            permite_multiplicar_cota: this.permite_multiplicar_cota,
            ultimo_hash: this.hashAtual
          })

          if (debugPolling) {
            console.log('📡 [verificarAtualizacoes] Resposta recebida:', {
              tem_atualizacao: resultado.data.tem_atualizacao,
              hash_anterior: this.hashAtual,
              hash_atual: resultado.data.hash_atual,
              quantidade_reservas_backend: resultado.data.quantidade_reservas,
              quantidade_reservas_locais: this.items.length,
              reservas_incluidas: resultado.data.reservas ? resultado.data.reservas.length : 'não incluídas'
            })
          }

          // Atualiza o hash conhecido
          this.hashAtual = resultado.data.hash_atual

          // 🔧 CORREÇÃO: Processar eventos ANTES de notificações (priorizar contextuais)
          // Processar eventos para notificações contextuais
          if (resultado.data.eventos && resultado.data.eventos.length > 0) {
            this.processarEventos(resultado.data.eventos)
          }

          // Processar notificações pendentes específicas (FRONT-5)
          // Somente se forem notificações com mensagens não-vazias e específicas
          if (resultado.data.notificacoes && resultado.data.notificacoes.length > 0) {
            const notificacoesEspecificas = resultado.data.notificacoes.filter(n =>
              n.mensagem && n.mensagem.trim() !== '' &&
              !n.mensagem.includes('Novas atualizações em suas reservas')
            )
            if (notificacoesEspecificas.length > 0) {
              this.processarNotificacoes(notificacoesEspecificas)
            }
          }

          // ✨ MELHORIA #1: Se há atualizações, usar dados incluídos no response
          if (resultado.data.tem_atualizacao) {
            if (debugPolling) {
              console.log('🔄 [verificarAtualizacoes] Atualizações detectadas! Processando...')
            }

            // Verificar se backend enviou dados completos
            if (resultado.data.reservas && resultado.data.reservas.length >= 0) {
              // Guardar snapshot anterior para detectar mudanças
              const reservasAntigas = this.items || []

              // ✅ Processar e atualizar dados (normaliza, filtra e ordena)
              // 🔧 FIX: Detectar mudanças APÓS processamento assíncrono completar
              this.processarEAtualizarReservas(resultado.data.reservas, () => {
                // Detectar mudanças específicas e exibir notificação contextual
                this.detectarENotificarMudancas(reservasAntigas, this.items)
              })
            } else {
              // Fallback: carregar dados se não vieram no response
              await this.loadReservas(true)
            }
          }
        } catch (error) {
          // Erros são tratados pelo PollingService (retry automático)
          throw error
        }
      },
      /**
       * Processa eventos recentes de reservas/pedidos para exibir notificações contextuais
       *
       * 🔧 FIX (2026-03-05): Agora processa apenas eventos de pedidos vindos de RESERVAS
       * Backend já filtra por id_reserva IS NOT NULL, evitando eventos de vendas diretas
       *
       * Exibe notificações de sucesso quando pedidos são enviados, permite ao usuário
       * receber feedback imediato sobre ações bem-sucedidas mesmo que não esteja ativamente
       * visualizando a tela.
       *
       * @param {Array} eventos - Array de eventos do backend
       * @example
       * [
       *   {
       *     tipo: 'pedido_enviado',
       *     id_pedido: 456,
       *     id_reserva: 123,
       *     timestamp: '2026-03-02T10:30:00-03:00'
       *   }
       * ]
       */
      processarEventos (eventos) {
        const debugPolling = localStorage.getItem('DEBUG_POLLING') === 'true'

        eventos.forEach(evento => {
          switch (evento.tipo) {
            case 'pedido_enviado':
              // 🔒 VALIDAÇÃO: Ignorar eventos sem id_reserva (não são de reservas)
              // Evita que notificações de propostas diretas apareçam na tela de Reservas
              if (!evento.id_reserva) {
                if (debugPolling) {
                  console.warn('[Reservas] Evento pedido_enviado sem id_reserva ignorado:', evento.id_pedido)
                }
                return
              }

              const chaveEvento = this.gerarChaveEvento(evento)

              if (this.eventosExibidos.has(chaveEvento)) {
                if (debugPolling) {
                  console.log('⏭️ [processarEventos] Evento já exibido anteriormente, ignorando:', {
                    id_pedido: evento.id_pedido,
                    id_reserva: evento.id_reserva,
                    chave: chaveEvento
                  })
                }
                return // Não exibir novamente
              }

              // Marcar como exibido
              this.eventosExibidos.add(chaveEvento)

              if (debugPolling) {
                console.log('✅ [processarEventos] Exibindo novo evento:', {
                  id_pedido: evento.id_pedido,
                  id_reserva: evento.id_reserva,
                  chave: chaveEvento,
                  total_exibidos: this.eventosExibidos.size
                })
              }

              // ✅ Eventos já filtrados no backend (apenas pedidos de reservas)
              const idExibicao = evento.id_documento != null && evento.id_documento !== '' ? evento.id_documento : evento.id_pedido
              const mensagem = `Proposta #${idExibicao} (Reserva #${evento.id_reserva}) enviada com sucesso!`

              notification(
                AlertTypes.SUCCESS,
                mensagem
              )
              break

            case 'erro_reserva':
              const chaveErro = this.gerarChaveEvento(evento)

              if (this.eventosExibidos.has(chaveErro)) {
                if (debugPolling) {
                  console.log('⏭️ [processarEventos] Evento de erro já exibido, ignorando')
                }
                return
              }

              this.eventosExibidos.add(chaveErro)

              notification(
                AlertTypes.ERROR,
                evento.mensagem || 'Ocorreu um erro em uma de suas reservas'
              )
              break

            default:
              // Ignorar eventos desconhecidos silenciosamente
              if (debugPolling) {
                console.warn('[Reservas] Evento desconhecido:', evento.tipo)
              }
          }
        })
      },
      /**
       * Combina tipo + id_pedido + timestamp para garantir unicidade mesmo em casos de:
       * - Pedidos atualizados
       * - Reprocessamento de eventos
       * - Múltiplas sessões de polling
       *
       * @param {Object} evento - Evento recebido do backend
       * @param {string} evento.tipo - Tipo do evento (ex: 'pedido_enviado', 'erro_reserva')
       * @param {number} evento.id_pedido - ID único do pedido
       * @param {string} evento.timestamp - Data/hora do evento em formato ISO8601
       * @returns {string} Chave única no formato "tipo:id:timestamp"
       *
       * @example
       * gerarChaveEvento({ tipo: 'pedido_enviado', id_pedido: 123, timestamp: '2026-03-05T10:30:00-03:00' })
       * // Retorna: "pedido_enviado:123:2026-03-05T10:30:00-03:00"
       */
      gerarChaveEvento (evento) {
        return `${evento.tipo}:${evento.id_pedido}:${evento.timestamp}`
      },
      /**
       * Detecta mudanças específicas entre reservas antigas e novas e exibe notificações contextuais
       * Implementa lógica similar ao websocket para detectar cotas processadas/adicionadas
       *
       * @param {Array} reservasAntigas - Lista de reservas antes da atualização
       * @param {Array} reservasNovas - Lista de reservas após a atualização
       */
      detectarENotificarMudancas (reservasAntigas, reservasNovas) {
        const debugPolling = localStorage.getItem('DEBUG_POLLING') === 'true'

        // Se não há reservas antigas (primeira carga), não notifica
        if (!reservasAntigas || reservasAntigas.length === 0) {
          return
        }

        // 🔧 CORREÇÃO: Verificar se os dados são realmente diferentes antes de continuar
        // Gerar hash simples dos IDs e timestamps para comparação rápida
        const hashAntigo = JSON.stringify(reservasAntigas.map(r => ({
          id: r.id_reserva || r.id_carrinho,
          dt_validade: r.dt_validade,
          erro_reserva: r.erro_reserva,
          reserva_em_geracao: r.reserva_em_geracao,
          updated_at: r.updated_at
        })))
        const hashNovo = JSON.stringify(reservasNovas.map(r => ({
          id: r.id_reserva || r.id_carrinho,
          dt_validade: r.dt_validade,
          erro_reserva: r.erro_reserva,
          reserva_em_geracao: r.reserva_em_geracao,
          updated_at: r.updated_at
        })))

        if (hashAntigo === hashNovo) {
          if (debugPolling) {
            console.log('⏭️ [detectarENotificarMudancas] Dados idênticos - sem mudanças reais, não notificar')
          }
          return
        }

        if (debugPolling) {
          console.log('🔍 [detectarENotificarMudancas] Comparando reservas:', {
            quantidadeAnterior: reservasAntigas.length,
            quantidadeAtual: reservasNovas.length,
            diferenca: reservasNovas.length - reservasAntigas.length,
            hashDiferente: true
          })
        }

        // Extrair todas as cotas das reservas antigas e novas
        const cotasAntigas = this.extrairCotasDeReservas(reservasAntigas)
        const cotasNovas = this.extrairCotasDeReservas(reservasNovas)

        if (debugPolling) {
          console.log('📊 [detectarENotificarMudancas] Análise de cotas:', {
            cotasAntigas: cotasAntigas.length,
            cotasNovas: cotasNovas.length,
            codsCotasAntigas: cotasAntigas.map(c => c.cd_cota).join(', '),
            codsCotasNovas: cotasNovas.map(c => c.cd_cota).join(', ')
          })
        }

        // Detectar cotas removidas (processadas com sucesso)
        const cotasProcessadas = cotasAntigas.filter(cota =>
          !cotasNovas.some(c => c.cd_cota === cota.cd_cota)
        )

        // Detectar cotas adicionadas (novas reservas)
        const cotasAdicionadas = cotasNovas.filter(cota =>
          !cotasAntigas.some(c => c.cd_cota === cota.cd_cota)
        )

        if (debugPolling) {
          console.log('🔄 [detectarENotificarMudancas] Mudanças detectadas:', {
            cotasRemovidas: cotasProcessadas.length,
            cotasAdicionadas: cotasAdicionadas.length,
            cotasRemovidasCods: cotasProcessadas.map(c => c.cd_cota).join(', '),
            cotasAdicionadasCods: cotasAdicionadas.map(c => c.cd_cota).join(', ')
          })
        }

        // Priorizar notificação de cotas processadas
        if (cotasProcessadas.length > 0) {
          if (debugPolling) {
            console.log('🗑️ [detectarENotificarMudancas] Cotas removidas detectadas (cancelamento ou conversão)')
          }
          this.notificarCotasProcessadas(cotasProcessadas)
          return
        }

        // Detectar se alguma reserva teve reserva_em_geracao alterado para false (geração concluída)
        const reservasGeracaoConcluida = reservasNovas.filter(reservaNova => {
          const reservaAntiga = reservasAntigas.find(r =>
            (r.id_reserva && r.id_reserva === reservaNova.id_reserva) ||
            (r.id_carrinho && r.id_carrinho === reservaNova.id_carrinho)
          )

          if (reservaAntiga) {
            const geracaoFinalizada = reservaAntiga.reserva_em_geracao && !reservaNova.reserva_em_geracao
            return geracaoFinalizada
          }
          return false
        })

        if (reservasGeracaoConcluida.length > 0 && debugPolling) {
          console.log('✅ [detectarENotificarMudancas] Reservas concluíram geração:', {
            quantidade: reservasGeracaoConcluida.length,
            ids: reservasGeracaoConcluida.map(r => r.id_reserva || r.id_carrinho),
            detalhes: reservasGeracaoConcluida.map(r => ({
              id: r.id_reserva || r.id_carrinho,
              erro_reserva: r.erro_reserva,
              status: r.erro_reserva ? 'COM ERRO' : 'SUCESSO',
              cd_grupo: r.grupo?.cd_grupo || r.cd_grupo,
              cd_cota: r.cd_cota
            }))
          })
        }

        // Notificar cotas adicionadas
        if (cotasAdicionadas.length > 0) {
          if (debugPolling) {
            console.log('➕ [detectarENotificarMudancas] Novas cotas adicionadas')
          }
          this.notificarCotasAdicionadas(cotasAdicionadas)
          return
        }

        // Se não há cotas processadas/adicionadas, mas há mudança de hash,
        // significa que houve alteração em dados (updated_at, erro, etc)
        if (reservasAntigas.length !== reservasNovas.length) {
          if (debugPolling) {
            console.log('📝 [detectarENotificarMudancas] Quantidade de reservas mudou sem mudança de cotas')
          }

          // 🔧 CORREÇÃO: Mostrar informações específicas sempre que possível
          if (reservasNovas.length > 0) {
            const primeira = reservasNovas[0]
            const cd_grupo = primeira.grupo?.cd_grupo ||
                            primeira.grupo?.CD_Grupo ||
                            primeira.cd_grupo ||
                            primeira.id_grupo

            // Validar se cd_grupo é válido
            if (!cd_grupo || cd_grupo === 'undefined' || cd_grupo === 'null') {
              if (debugPolling) {
                console.warn('⚠️ [detectarENotificarMudancas] cd_grupo inválido ao mudar quantidade:', primeira)
              }
              notification(AlertTypes.INFO, 'Suas reservas foram atualizadas.')
            } else {
              let mensagem
              if (primeira.reserva_agrupada) {
                mensagem = `Reservas do grupo ${cd_grupo} (${primeira.qt_cota} cotas) foram atualizadas.`
              } else {
                mensagem = `Reserva do grupo ${cd_grupo}, cota ${primeira.cd_cota} foi atualizada.`
              }
              notification(AlertTypes.INFO, mensagem)
            }
          } else {
            notification(AlertTypes.INFO, 'Suas reservas foram atualizadas.')
          }
        } else {
          // Detectar quais reservas tiveram mudanças nos dados
          const reservasModificadas = []

          reservasNovas.forEach(reservaNova => {
            const reservaAntiga = reservasAntigas.find(r =>
              (r.id_reserva && r.id_reserva === reservaNova.id_reserva) ||
              (r.id_carrinho && r.id_carrinho === reservaNova.id_carrinho)
            )

            if (reservaAntiga) {
              // Verificar se houve mudança em campos relevantes
              const houveAlteracao =
                reservaAntiga.dt_validade !== reservaNova.dt_validade ||
                reservaAntiga.erro_reserva !== reservaNova.erro_reserva ||
                reservaAntiga.reserva_em_geracao !== reservaNova.reserva_em_geracao ||
                reservaAntiga.dt_reserva !== reservaNova.dt_reserva ||
                reservaAntiga.cd_cota !== reservaNova.cd_cota

              if (houveAlteracao) {
                // Extrair cd_grupo de múltiplas fontes possíveis
                const cd_grupo = reservaNova.grupo?.cd_grupo ||
                                reservaNova.grupo?.CD_Grupo ||
                                reservaNova.cd_grupo ||
                                reservaNova.id_grupo

                if (debugPolling) {
                  console.log('🔍 [detectarENotificarMudancas] Mudança detectada em reserva:', {
                    id: reservaNova.id_reserva || reservaNova.id_carrinho,
                    campos_alterados: {
                      dt_validade: reservaAntiga.dt_validade !== reservaNova.dt_validade,
                      erro_reserva: reservaAntiga.erro_reserva !== reservaNova.erro_reserva,
                      reserva_em_geracao: reservaAntiga.reserva_em_geracao !== reservaNova.reserva_em_geracao,
                      dt_reserva: reservaAntiga.dt_reserva !== reservaNova.dt_reserva,
                      cd_cota: reservaAntiga.cd_cota !== reservaNova.cd_cota
                    },
                    valores_anteriores: {
                      dt_validade: reservaAntiga.dt_validade,
                      erro_reserva: reservaAntiga.erro_reserva,
                      reserva_em_geracao: reservaAntiga.reserva_em_geracao
                    },
                    valores_novos: {
                      dt_validade: reservaNova.dt_validade,
                      erro_reserva: reservaNova.erro_reserva,
                      reserva_em_geracao: reservaNova.reserva_em_geracao
                    }
                  })

                  // 🚨 ALERTA ESPECIAL: Mudança em reserva_em_geracao (botão)
                  if (reservaAntiga.reserva_em_geracao !== reservaNova.reserva_em_geracao) {
                    console.log('🔴 [IMPORTANTE] reserva_em_geracao mudou:', {
                      id: reservaNova.id_reserva || reservaNova.id_carrinho,
                      de: reservaAntiga.reserva_em_geracao,
                      para: reservaNova.reserva_em_geracao,
                      significado: reservaNova.reserva_em_geracao ? 'Botão deve mostrar GERANDO' : 'Botão deve sumir/normalizar'
                    })
                  }
                }

                reservasModificadas.push({
                  cd_grupo: cd_grupo,
                  cd_cota: reservaNova.cd_cota,
                  id_reserva: reservaNova.id_reserva,
                  reserva_agrupada: reservaNova.reserva_agrupada,
                  qt_cota: reservaNova.qt_cota
                })
              }
            }
          })

          if (debugPolling) {
            console.log('🔧 [detectarENotificarMudancas] Dados das reservas foram atualizados', {
              reservasModificadas: reservasModificadas.length,
              detalhes: reservasModificadas
            })
          }

          // Formatar mensagem com grupo e cota
          if (reservasModificadas.length > 0) {
            if (debugPolling) {
              console.log('📋 [detectarENotificarMudancas] Formatando notificação:', {
                quantidade: reservasModificadas.length,
                dados: reservasModificadas
              })
            }

            let mensagem
            if (reservasModificadas.length === 1) {
              const r = reservasModificadas[0]
              // 🔧 CORREÇÃO: Validar cd_grupo antes de usar
              if (!r.cd_grupo || r.cd_grupo === 'undefined' || r.cd_grupo === 'null') {
                if (debugPolling) {
                  console.warn('⚠️ [detectarENotificarMudancas] cd_grupo inválido:', r)
                }
                mensagem = 'Dados de uma reserva foram atualizados.'
              } else if (r.reserva_agrupada) {
                mensagem = `Dados do grupo ${r.cd_grupo} (${r.qt_cota} cotas) foram atualizados.`
              } else {
                mensagem = `Dados do grupo ${r.cd_grupo}, cota ${r.cd_cota} foram atualizados.`
              }
            } else if (reservasModificadas.length <= 3) {
              const grupos = reservasModificadas.map(r => {
                if (r.reserva_agrupada) {
                  return `${r.cd_grupo} (${r.qt_cota} cotas)`
                }
                return `${r.cd_grupo}/${r.cd_cota}`
              }).join(', ')
              mensagem = `Dados atualizados: ${grupos}.`
            } else {
              mensagem = `Dados de ${reservasModificadas.length} reservas foram atualizados.`
            }

            if (debugPolling) {
              console.log('✅ [detectarENotificarMudancas] Notificação enviada:', mensagem)
            }
            notification(AlertTypes.INFO, mensagem)
          } else {
            // 🔧 CORREÇÃO: Se não detectou mudanças específicas, NÃO notificar
            // O hash inicial já validou que há diferença, então isso só acontece
            // quando a mudança não é em campos monitorados (ex: apenas updated_at)
            if (debugPolling) {
              console.log('⏭️ [detectarENotificarMudancas] Mudança apenas em campos não-relevantes, não notificar')
              console.log('📊 [detectarENotificarMudancas] Comparação detalhada:', {
                reservasAntigas: reservasAntigas.map(r => ({
                  id: r.id_reserva || r.id_carrinho,
                  dt_validade: r.dt_validade,
                  erro_reserva: r.erro_reserva,
                  reserva_em_geracao: r.reserva_em_geracao,
                  dt_reserva: r.dt_reserva,
                  cd_cota: r.cd_cota
                })),
                reservasNovas: reservasNovas.map(r => ({
                  id: r.id_reserva || r.id_carrinho,
                  dt_validade: r.dt_validade,
                  erro_reserva: r.erro_reserva,
                  reserva_em_geracao: r.reserva_em_geracao,
                  dt_reserva: r.dt_reserva,
                  cd_cota: r.cd_cota
                }))
              })
            }
          }
        }
      },
      /**
       * Extrai todas as cotas de uma lista de reservas (incluindo agrupadas)
       *
       * @param {Array} reservas - Lista de reservas
       * @returns {Array} Array de objetos com cd_cota e id_reserva
       */
      extrairCotasDeReservas (reservas) {
        const cotas = []

        reservas.forEach(reserva => {
          // Verifica se é uma reserva agrupada
          if (reserva.todasAsReservasAgrupadas && Array.isArray(reserva.todasAsReservasAgrupadas)) {
            reserva.todasAsReservasAgrupadas.forEach(subReserva => {
              cotas.push({
                cd_cota: subReserva.cd_cota,
                id_reserva: subReserva.id_reserva,
                id_carrinho: reserva.id_carrinho
              })
            })
          } else {
            // Reserva individual
            cotas.push({
              cd_cota: reserva.cd_cota,
              id_reserva: reserva.id_reserva,
              id_carrinho: reserva.id_carrinho
            })
          }
        })

        return cotas
      },
      /**
       * Exibe notificação de cotas removidas da lista
       * Pode ocorrer por cancelamento ou processamento externo
       *
       * @param {Array} cotas - Array de cotas processadas
       */
      notificarCotasProcessadas (cotas) {
        const quantidade = cotas.length
        const listaCotasFormatada = this.formatarListaCotas(cotas.map(c => c.cd_cota))

        let mensagem
        if (quantidade === 1) {
          mensagem = `Cota ${listaCotasFormatada} foi removida da lista de reservas (cancelamento/processamento).`
        } else if (quantidade <= 5) {
          mensagem = `Cotas ${listaCotasFormatada} foram removidas da lista de reservas (cancelamento/processamento).`
        } else {
          // Se muitas cotas, mostrar apenas quantidade
          mensagem = `${quantidade} cotas foram removidas da lista de reservas (cancelamento/processamento).`
        }

        notification(AlertTypes.INFO, mensagem)

        const debugPolling = localStorage.getItem('DEBUG_POLLING') === 'true'
        if (debugPolling) {
          console.log('[Reservas] Cotas processadas:', cotas)
        }
      },
      /**
       * Exibe notificação de novas cotas adicionadas
       * Segue padrão do websocket: lista as cotas que foram adicionadas
       *
       * @param {Array} cotas - Array de cotas adicionadas
       */
      notificarCotasAdicionadas (cotas) {
        const quantidade = cotas.length
        const listaCotasFormatada = this.formatarListaCotas(cotas.map(c => c.cd_cota))

        let mensagem
        if (quantidade === 1) {
          mensagem = `Nova cota ${listaCotasFormatada} adicionada.`
        } else if (quantidade <= 5) {
          mensagem = `Novas cotas ${listaCotasFormatada} adicionadas.`
        } else {
          // Se muitas cotas, mostrar apenas quantidade
          mensagem = `${quantidade} novas cotas adicionadas.`
        }

        notification(AlertTypes.INFO, mensagem)

        const debugPolling = localStorage.getItem('DEBUG_POLLING') === 'true'
        if (debugPolling) {
          console.log('[Reservas] Cotas adicionadas:', cotas)
        }
      },
      /**
       * Formata uma lista de cotas para exibição
       * Exemplos: "123", "123 e 456", "123, 456 e 789"
       *
       * @param {Array} cotas - Array de códigos de cota
       * @returns {string} String formatada
       */
      formatarListaCotas (cotas) {
        if (cotas.length === 0) return ''
        if (cotas.length === 1) return cotas[0]
        if (cotas.length === 2) return `${cotas[0]} e ${cotas[1]}`

        // 3 ou mais: "123, 456 e 789"
        const ultimaCota = cotas[cotas.length - 1]
        const demaisCotas = cotas.slice(0, -1).join(', ')
        return `${demaisCotas} e ${ultimaCota}`
      },
      /**
       * Processa metadados de mudança para exibir notificações contextuais (MELHORIA #2)
       * @deprecated Usar detectarENotificarMudancas() ao invés
       *
       * @param {Object} metadados - Metadados da mudança do backend
       */
      processarMetadadosMudanca (metadados) {
        if (!metadados || !metadados.descricao) {
          return
        }

        // Determinar tipo de alerta baseado no tipo de mudança
        let alertType = AlertTypes.INFO

        switch (metadados.tipo_mudanca) {
          case 'todas_cotas_processadas':
          case 'cotas_processadas':
            alertType = AlertTypes.SUCCESS
            break
          case 'estrutura_alterada':
          case 'reservas_atualizadas':
            alertType = AlertTypes.INFO
            break
          default:
            alertType = AlertTypes.INFO
        }

        // Exibir notificação
        notification(alertType, metadados.descricao)

        const debugPolling = localStorage.getItem('DEBUG_POLLING') === 'true'
        if (debugPolling) {
          console.log('[Reservas] Metadados de mudança:', metadados)
        }
      },
      /**
       * Processa notificações pendentes do sistema de reservas (FRONT-5)
       *
       * Exibe notificações persistentes que foram geradas pelo backend e ainda não foram
       * enviadas ao usuário. Após exibir, marca as notificações como enviadas.
       *
       * ✨ MELHORIA #7: Agrupa notificações similares para evitar spam
       *
       * @param {Array} notificacoes - Array de notificações do backend
       * @example
       * [
       *   {
       *     id: 123,
       *     tipo: 'error',
       *     mensagem: 'Cota 1001 indisponível - grupo já contemplado',
       *     timestamp: '2026-03-03T10:30:00-03:00'
       *   }
       * ]
       */
      async processarNotificacoes (notificacoes) {
        const debugPolling = localStorage.getItem('DEBUG_POLLING') === 'true'

        if (debugPolling) {
          console.log('📬 [processarNotificacoes] Notificações recebidas:', {
            quantidade: notificacoes.length,
            detalhes: notificacoes.map(n => ({
              id: n.id,
              tipo: n.tipo,
              mensagem: n.mensagem,
              timestamp: n.timestamp
            }))
          })
        }

        // ✨ MELHORIA #7: Agrupa notificações similares
        const agrupadas = this.agruparNotificacoesSimilares(notificacoes)

        // Array para armazenar IDs das notificações processadas
        const idsProcessados = []

        agrupadas.forEach(grupo => {
          // Mapear tipo de notificação para AlertTypes
          let alertType = AlertTypes.INFO

          switch (grupo.tipo) {
            case 'error':
              alertType = AlertTypes.ERROR
              break
            case 'warning':
              alertType = AlertTypes.WARNING
              break
            case 'success':
              alertType = AlertTypes.SUCCESS
              break
            case 'info':
            default:
              alertType = AlertTypes.INFO
              break
          }

          // Exibir notificação (única ou agrupada)
          if (grupo.items.length === 1) {
            if (debugPolling) {
              console.log('🔔 [processarNotificacoes] Exibindo notificação:', {
                tipo: alertType,
                mensagem: grupo.items[0].mensagem
              })
            }
            notification(alertType, grupo.items[0].mensagem)
          } else {
            // Múltiplas notificações do mesmo tipo
            if (debugPolling) {
              console.log('🔔 [processarNotificacoes] Exibindo notificação agrupada:', {
                tipo: alertType,
                resumo: grupo.resumo,
                quantidade: grupo.items.length
              })
            }
            notification(alertType, grupo.resumo)
          }

          // Adicionar todos os IDs do grupo para marcação (garantir que são números)
          grupo.items.forEach(notif => {
            const id = Number(notif.id)
            if (!isNaN(id)) {
              idsProcessados.push(id)
            } else if (debugPolling) {
              console.warn('⚠️ [processarNotificacoes] ID inválido ignorado:', notif.id)
            }
          })
        })

        // Marcar notificações como enviadas no backend
        if (idsProcessados.length > 0) {
          try {
            if (debugPolling) {
              console.log('✅ [processarNotificacoes] Marcando notificações como lidas:', {
                quantidade: idsProcessados.length,
                ids: idsProcessados,
                tipos: idsProcessados.map(id => typeof id)
              })
            }
            await marcarNotificacoesEnviadas({ ids: idsProcessados })
            if (debugPolling) {
              console.log('✅ [processarNotificacoes] Notificações marcadas com sucesso')
            }
          } catch (error) {
            // Erro ao marcar não deve quebrar o fluxo
            // Notificações serão reexibidas na próxima verificação se não marcadas
            console.error('❌ [processarNotificacoes] Erro ao marcar notificações como enviadas:', error)
          }
        }
      },
      /**
       * Agrupa notificações similares para evitar spam (MELHORIA #7)
       *
       * Analisa notificações e agrupa aquelas com tipos e padrões de mensagem similares,
       * criando um resumo quando há múltiplas notificações relacionadas.
       *
       * @param {Array} notificacoes - Array de notificações do backend
       * @returns {Array} Array de grupos de notificações
       * @example
       * // Entrada:
       * [
       *   { id: 1, tipo: 'error', mensagem: 'Cota 1001 indisponível' },
       *   { id: 2, tipo: 'error', mensagem: 'Cota 1002 indisponível' },
       *   { id: 3, tipo: 'success', mensagem: 'Proposta enviada' }
       * ]
       *
       * // Saída:
       * [
       *   {
       *     tipo: 'error',
       *     items: [{ id: 1, ... }, { id: 2, ... }],
       *     resumo: '2 cotas indisponíveis: 1001, 1002'
       *   },
       *   {
       *     tipo: 'success',
       *     items: [{ id: 3, ... }],
       *     resumo: null
       *   }
       * ]
       */
      agruparNotificacoesSimilares (notificacoes) {
        if (!notificacoes || notificacoes.length === 0) {
          return []
        }

        // Agrupa notificações por tipo
        const grupos = {}

        notificacoes.forEach(notif => {
          const tipo = notif.tipo || 'info'

          if (!grupos[tipo]) {
            grupos[tipo] = []
          }

          grupos[tipo].push(notif)
        })

        // Processa cada grupo
        const resultado = []

        Object.keys(grupos).forEach(tipo => {
          const items = grupos[tipo]

          if (items.length === 1) {
            // Notificação única - não precisa agrupar
            resultado.push({
              tipo,
              items,
              resumo: null
            })
          } else {
            // Múltiplas notificações do mesmo tipo - tentar agrupar
            const resumo = this.gerarResumoNotificacoes(items, tipo)

            resultado.push({
              tipo,
              items,
              resumo
            })
          }
        })

        return resultado
      },
      /**
       * Gera um resumo textual para múltiplas notificações agrupadas
       *
       * @param {Array} items - Notificações do mesmo tipo
       * @param {string} tipo - Tipo das notificações
       * @returns {string} Texto do resumo
       * @private
       */
      gerarResumoNotificacoes (items, tipo) {
        const quantidade = items.length

        // Tentar extrair cotas das mensagens
        const cotas = []
        const regexCota = /cota\s+(\d+)/gi

        items.forEach(item => {
          const matches = [...item.mensagem.matchAll(regexCota)]
          matches.forEach(match => cotas.push(match[1]))
        })

        if (cotas.length > 0) {
          // Tem cotas identificadas - criar resumo específico
          const cotasUnicas = [...new Set(cotas)]

          if (cotasUnicas.length <= 3) {
            return `${quantidade} notificações sobre cotas: ${cotasUnicas.join(', ')}`
          } else {
            return `${quantidade} notificações sobre ${cotasUnicas.length} cotas diferentes`
          }
        }

        // Resumo genérico baseado no tipo
        const resumos = {
          error: `${quantidade} erros detectados`,
          warning: `${quantidade} avisos`,
          success: `${quantidade} ações concluídas com sucesso`,
          info: `${quantidade} informações`
        }

        return resumos[tipo] || `${quantidade} notificações`
      },
      /**
       * Para o polling automático e limpa todos os recursos associados
       *
       * Deve ser chamado no beforeDestroy() para evitar memory leaks.
       * Remove instância do PollingService e reseta propriedades relacionadas.
       *
       * @see iniciarPolling Método que cria o polling
       */
      pararPolling () {
        if (this.pollingService) {
          this.pollingService.destroy()
          this.pollingService = null
        }
        this.hashAtual = null
      },
      /**
       * Gerencia o comportamento do polling com base na visibilidade da página
       *
       * Utiliza a Page Visibility API para pausar o polling quando a aba/janela
       * não está visível (economizando recursos) e retomá-lo quando volta a ser visível.
       *
       * Benefícios:
       * - Economiza bateria em dispositivos móveis
       * - Reduz uso de CPU quando a aba está em segundo plano
       * - Atualização imediata ao retornar para a aba
       *
       * Compatibilidade:
       * - Chrome/Edge: Suporte completo
       * - Firefox: Suporte completo
       * - Safari: Suporte completo
       * - IE11+: Suporte completo
       *
       * @private
       * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/Page_Visibility_API|MDN Page Visibility API}
       */
      handleVisibilityChange () {
        if (!this.pollingService) {
          return
        }

        if (document.hidden) {
          // Página não está visível - pausar polling
          const debugPolling = localStorage.getItem('DEBUG_POLLING') === 'true'
          if (debugPolling) {
            console.log('[Reservas] Página oculta - pausando polling')
          }
          this.pollingService.pause()
        } else {
          // Página voltou a ser visível - retomar polling
          const debugPolling = localStorage.getItem('DEBUG_POLLING') === 'true'
          if (debugPolling) {
            console.log('[Reservas] Página visível - retomando polling')
          }
          this.pollingService.resume(true) // executeImmediately = true
        }
      },
      async atualizarReservasDoCarrinho () {
        const id_empresa = this.id_empresa

        return this.$http.get('/reservas/listar',
                              { params: { id_empresa, id_comissionado: this.id_comissionado_venda, permite_multiplicar_cota: this.permite_multiplicar_cota },
                                options: { silent: true }
                              })
          .then(reservas => {
            reservas.data.Reservas.forEach(reserva => {
              if (!reserva.hasOwnProperty('id_carrinho')) {
                return
              }
              const itemIndex = this.items.findIndex(
                item => item.id_carrinho === reserva.id_carrinho
              )
              if (itemIndex !== -1) {
                let newItems = [...this.items]
                newItems[itemIndex] = reserva
                this.items = newItems
              }
            })
          })
          .catch((error) => {
            console.error(error)
          })
      },
      configurarMonitoramentoWebSocket () {
        const reservasPorCarrinho = new Map()
        this.reservas.forEach(reserva => {
          if (!reserva.id_carrinho) return
          if (reserva.reserva_agrupada && reserva.todasAsReservasAgrupadas) {
            reserva.todasAsReservasAgrupadas.forEach(subReserva => {
              if (subReserva.reserva_em_geracao) {
                if (!reservasPorCarrinho.has(reserva.id_carrinho)) {
                  reservasPorCarrinho.set(reserva.id_carrinho, [])
                }
                reservasPorCarrinho.get(reserva.id_carrinho).push({
                  cd_cota: subReserva.cd_cota,
                  updated_at: subReserva.updated_at
                })
              }
            })
          } else if (reserva.reserva_em_geracao) {
            if (!reservasPorCarrinho.has(reserva.id_carrinho)) {
              reservasPorCarrinho.set(reserva.id_carrinho, [])
            }
            reservasPorCarrinho.get(reserva.id_carrinho).push({
              cd_cota: reserva.cd_cota,
              updated_at: reserva.updated_at
            })
          }
        })

        const reservasMonitoramento = Array.from(reservasPorCarrinho.entries()).map(([id_carrinho, todasAsReservasAgrupadas]) => ({
          id_carrinho: parseInt(id_carrinho),
          todasAsReservasAgrupadas
        }))
        this.adicionarReservasMonitoramento(reservasMonitoramento)
      },
      reservasEmGeracaoTodasComErro (item) {
        if (item.reserva_agrupada && item.todasAsReservasAgrupadas) {
          const temReservaComSucesso = item.todasAsReservasAgrupadas.some(cota => !!cota.id_reserva)

          if (temReservaComSucesso) {
            return true
          }

          const todasComErro = item.todasAsReservasAgrupadas.every(cota => cota.erro_reserva)
          return todasComErro
        }
        const temErro = !!item.erro_reserva
        return temErro
      },
      iniciarIndicativoReservas (item) {
        return item.reserva_agrupada && item.reserva_em_geracao
      },
      filtrar () {
        this.page = 1
        if (this.$refs.filter.validate()) {
          this.search = { ...this.filters }
        }
      },
      isGrupoBloqueado (grupo) {
        return grupo.bloqueia_cotas_vagas || grupo.bloqueia_furo || grupo.bloqueia_plano_venda || grupo.bloqueia_condicoes_venda
      },
      getGrupoMsgErro (grupo) {
        if (grupo.bloqueia_cotas_vagas) {
          return ': O Grupo não tem cotas vagas'
        } else if (grupo.bloqueia_furo) {
          return ': Não há prazo disponível para esse grupo'
        } else if (grupo.bloqueia_plano_venda) {
          return ': Plano de venda não disponível'
        } else if (grupo.bloqueia_condicoes_venda) {
          return ': Condições de venda não disponíveis'
        }
        return ''
      },
      async irParaCadastro () {
        if (this.item.id_carrinho) {
          const id_reservas_desejados = this.item.cotasDesejadas
          const qt_cotas = await this.ajustarCarrinhos(this.item.id_carrinho, !!this.item.desmenbrarProposta, id_reservas_desejados)
          this.item.id_reserva = id_reservas_desejados[0]
          if (qt_cotas > 1) {
            this.item.carrinho = {
              id_carrinho: this.item.id_carrinho,
              qt_cotas: qt_cotas,
              reserva_com_carrinho: true
            }
          }
        }
        if (this.item.origem === 'politica_vendas') {
          let condicao_venda = {
            cd_bem: '',
            cd_grupo: this.item.cd_grupo,
            nm_plano_venda: this.item.nome_plano,
            cd_plano_venda: this.item.cd_plano_venda,
            num_maximo_cotas: 0,
            vagas: 0,
            assembleias_realizadas: 0,
            credito_menor: 0,
            credito_maior: 0,
            categoria: '',
            id_plano_venda: this.item.id_plano_venda,
            id_grupo: this.item.id_grupo,
            id_produto: this.item.id_produto,
            prazos: [],
            permite_reservar: 0,
            id_bem: this.item.id_bem,
            id_reserva: this.item.id_reserva,
            st_situacao: this.item.situacao_grupo,
            pz_comercializacao: this.item.pz_comercializacao,
            modalidade_selecionada_index: 0,
            cd_produto: this.item.cd_produto
          }
          this.$router.push({ name: 'selecionar-bem-politica-vendas', params: condicao_venda })
        } else if (this.item.completa) {
          clearInterval(this.atualizarReservasDoCarrinhoInterval)
          this.atualizarReservasDoCarrinhoInterval = null
          this.$router.push({ name: 'cadastro', params: this.item })
        } else {
          this.$router.push({ name: 'iniciar-venda', params: { ...this.item } })
        }
      },
      async ajustarCarrinhos (id_carrinho, desmenbrarProposta, ids_reservas_desejados) {
        return this.$http.post('/carrinho/ajustar_carrinho', {
          id_carrinho,
          desmenbrarProposta,
          selectedReservas: ids_reservas_desejados
        }).then((res) => {
          return res.data.qt_cotas
        }).catch((err) => {
          notification(AlertTypes.ERROR, 'Ocorreu um erro ao criar seu carrinho de compras, por favor tente novamente mais tarde, caso persistir entre em contato com a Área de Suporte.')
          throw err
        })
      },
      showSuccessNotification (titulo, detalhes) {
        notification(AlertTypes.SUCCESS, `${titulo} ${detalhes}.`)
      }
    }
  }
</script>

<style scoped lang="scss">
    .round-corner {
        border-right: 8px;
    }

    .title.cabecalho {
        justify-content: flex-end;
        padding: 12px;

        span {
            width: 100%;
            font-size: 1.2rem;
            text-transform: uppercase;
            color: var(--secondary);
            text-align: center;
        }

        span.title {
            margin: 8px;
            color: var(--primary);

        }
    }

    .close-button {
        position: absolute;
        top: 8px;
        right: 12px;
        outline: none;
    }

    .circle {
        border-radius: 50% !important;
        position: absolute;
        height: 45px;
        width: 45px;
        top: -20px;
        left: -20px;
    }

    .icon {
        font-size: 2rem;
    }

    .vendas .v-card:hover {
        background: var(--lightgray);
    }

    .theme--light.v-data-table .v-data-footer {
        border-top: none;
    }

    .disabled-card-text {
        color: #9e9e9e;
        opacity: 0.6;
        pointer-events: none;
    }
    .title {
      color: var(--secondary);
    }
    .subtitle {
      color: var(--primary);
    }
</style>
